import { render } from "./PengaturanView.vue?vue&type=template&id=a9737e54"
import script from "./PengaturanView.vue?vue&type=script&lang=js"
export * from "./PengaturanView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__